import { apiForms } from 'services/apiService';

// ------------------------------------
// DTOs retornados pela sua API
// ------------------------------------
export interface FieldDTO {
  id: string;
  label: string;
  short_label?: string | null;
  field_type: string;
  is_required?: boolean;
  description?: string | null;
  form: { id: string; form_name: string; description?: string | null };
  slug?: string | null;
}

export interface OptionDTO {
  id: string;
  option_label: string;
  short_label?: string | null;
  field_id: string;
  rank?: number;
}

// ------------------------------------
// API
// ------------------------------------
export const formsApi = {
  getAllFields: async (): Promise<FieldDTO[]> => {
    const { data } = await apiForms.get('/v1/fields/all');
    return data ?? [];
  },

  getFieldOptions: async (fieldId: string): Promise<OptionDTO[]> => {
    const { data } = await apiForms.get(`/v1/fields/${fieldId}/options`);
    return data ?? [];
  },
};
